<template>
  <div v-loading.body="loading" element-loading-text="加载中..." class="app-container">
    <el-card shadow="never" :body-style="{ padding: 0 }" class="sticky-container">
      <template slot="header">
        <order-search :params.sync="queryParams" :suppliers="suppliers" :order-count="orderCount" @filter="handleFilter" @import="handleImport" />
      </template>

      <order-table :list="list" is-premium @verify="pickupVerify" />
      <pagination :total="total" :page.sync="queryParams.page" :limit.sync="queryParams.limit" @pagination="fetchData" />
    </el-card>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import OrderTable from '@/components/Order/order-table'
import OrderSearch from '@/components/Order/order-search'
import { getUnshippedSuppliers } from '@/api/supplier'
import { getOrderList, getOrderCount } from '@/api/order'

export default {
  name: 'PremiumOrderList',
  components: {
    Pagination,
    OrderTable,
    OrderSearch
  },
  data() {
    return {
      list: null,
      total: 0,
      loading: false,
      queryParams: {
        keyword: '', // 关键词（用户昵称、手机号、分享码）
        dateRange: '', // 下单日期范围
        orderNumber: '',
        orderStatus: '0',
        orderType: 75000, // 优品商城订单
        payNumber: '',
        logisticsNumber: '',
        dateStart: '',
        dateEnd: '',
        supplierId: '',
        supplierName: '',
        consigneeInfo: '',
        page: 1,
        limit: 20
      },
      suppliers: [],
      orderCount: {
        all: 0,
        paid: 0,
        verified: 0,
        delivered: 0,
        completed: 0
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData(action = '') {
      this.loading = true
      const params = Object.assign({}, this.queryParams)
      if (params.dateStart) params.dateStart += ' 00:00:00'
      if (params.dateEnd) params.dateEnd += ' 23:59:59'
      this.orderCount = await getOrderCount(params)
      const orders = await getOrderList(params)
      this.list = orders.records
      this.total = orders.total
      if (action === 'tab' && ['2', '5'].includes(this.queryParams.orderStatus)) {
        const params = { orderType: this.queryParams.orderType, orderStatus: this.queryParams.orderStatus }
        this.suppliers = await getUnshippedSuppliers(params)
      } else {
        this.suppliers = this.$store.state.base.supplierList
      }

      this.$util.delay().then(() => { this.loading = false })
    },
    handleFilter(e) {
      this.queryParams.page = 1
      this.fetchData(e.action)
    },
    handleImport() {
      this.handleFilter({ action: 'tab' })
    },
    pickupVerify() {
      this.queryParams.page = 1
      this.fetchData()
    }
  }
}
</script>
